// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"c0946a7a","159":"49026fd0","278":"1ece3375","280":"8419ce12","326":"f2b04e9b","488":"371f7511","600":"2d556c71","930":"01fc3af6"}[chunkId] + ".chunk.js";
};